import React, { useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";
import { MdOutlineAutoDelete } from "react-icons/md";
import { useUpdateNews } from "../../store/api/newsApi";
import { useGetNews } from "../../store/api/newsApi";
import { toast } from "react-toastify";
import useAuthToken from "../../Hooks/useAuthToken";

import { apiRequest } from "../../store/api/api";

function RoleList({ onEdit }) {
  const token = useAuthToken();
  const [loading, setLoading] = useState(false);
  const [deletId, saetDeletId] = useState(null);
  const updateNews = useUpdateNews(deletId);
  const getNews = useGetNews();

  const {
    data: newsData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["news"],
    queryFn: getNews,
  });

  // delete

  const mutation = useMutation({
    mutationFn: ({ id, data }) => {
      return apiRequest("patch", `/api/news/${id}`, data, token);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success("Successfully Deleted!");
      refetch();
    },
    onError: (error) => {
      toast.error(error.message || "Something went wrong!");
      setLoading(false);
    },
  });

  const onSubmit = (id) => {
    saetDeletId(id);

    alert("Are you sure you want to delete this news?");
    setLoading(true);
    try {
      const data = new FormData();
      data.append("status", "deleted");

      mutation.mutate({ id, data });
    } catch (error) {
      setLoading(false);
      console.error("Caught error in handleSubmit:", error.message);
      toast.error(error.message);
    }
  };

  const data = newsData?.news
    ?.map((news, index) => ({
      postId: news.newsidNumber,
      image: (
        <div
          style={{
            height: "80px",
            width: "80px",
            overflow: "hidden",
            borderRadius: "10px",
          }}
          className="shadow-sm"
        >
          <img
            src={news.image}
            alt="news"
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              transition: "transform 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </div>
      ),
      title:
        news?.title?.length > 20
          ? news?.title.slice(0, 20) + "..."
          : news?.title,
      status: (
        <span
          style={{
            padding: "3px 8px",
            borderRadius: "6px",
            background: news?.status ? "#d1fae5" : "#fee2e2",
            color: news?.status ? "#065f46" : "#991b1b",
            fontWeight: "600",
            fontSize: "12px",
          }}
        >
          {news?.status ? "Active" : "Inactive"}
        </span>
      ),

      topNews: news?.topNews ? "🟢 Yes" : "🔴 No",
      liveNews: news?.liveNews ? "🟢 Yes" : "🔴 No",
      leadNews: news?.leadNews ? "🟢 Yes" : "🔴 No",
      categoryPin: news?.categoryPin ? "📌 Pin" : "—",

      category: news?.categoryList?.map((cat) => cat.name).join(", ") || "",
      createdAt: new Date(news?.publishDate).toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      }),
      actionButton: (
        <>
          {loading ? (
            <button className="btn  mx-1">Loading...</button>
          ) : (
            <>
              <button
                onClick={() => onEdit(news)}
                className="btn text-success mx-1"
              >
                <MdEditDocument />
              </button>
              <button
                onClick={() => onSubmit(news._id)}
                className="btn text-danger mx-1"
              >
                <MdOutlineAutoDelete />
              </button>
            </>
          )}
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "ID",
      accessor: "postId",
    },
    {
      header: "Image",
      accessor: "image",
    },
    {
      header: "Title",
      accessor: "title",
    },
    {
      header: "Category",
      accessor: "category",
    },
    {
      header: "Status",
      accessor: "status",
    },
    {
      header: "Top News",
      accessor: "topNews",
    },
    {
      header: "Lead News",
      accessor: "leadNews",
    },
    {
      header: "Live News",
      accessor: "liveNews",
    },
    {
      header: "Category Pin",
      accessor: "categoryPin",
    },
    {
      header: "Publish Date",
      accessor: "createdAt",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isLoading} />
    </div>
  );
}

export default RoleList;
